<template>
  <v-card flat class="pa-4">
    <v-switch v-model="preferences.assemblyDuration" label="Track duration" dense/>
    <v-switch v-model="preferences.assemblyIncomplete" label="Allow incomplete assembly" dense/>
    <v-row dense class="mt-4">
      <v-col cols="3 pt-3">Numbering</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProductionAssemblyPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation ProductionAssemblyPreferences($input:AssemblingPreferencesInput!) {
                                              assemblingSetPreferences(input:$input) {
                                                assemblyDuration, assemblyIncomplete
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.assemblingSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query ProductionAssemblyPreferences {
                                          assemblingPreferences {
                                            assemblyDuration, assemblyIncomplete
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.assemblingPreferences;
  }
}
</script>